import {
    LayoutDashboard,
    Settings,
    MonitorUp,
    Inbox,
    Logs,
    Square,
    SquareSquare,
    Equal,
    SquarePercent,
    ShieldX,
    BookOpenCheck,
    CirclePause,
    Bug,
    LayoutTemplate,
    TableOfContents,
    List,
    User,
    UserRoundCheck,
    Group,
    ChartNoAxesCombined,
    Airplay,
    Diamond,
    BookOpenCheckIcon,
    SettingsIcon,
    Settings2,
    Boxes,
    BookLock,
    Lock,
    Workflow,
    GitCommitVertical,
    SquareChartGantt,
    Edit,
} from 'lucide-react'

const SidebarMenu = () => {
    return {
        navMain: [
            {
                title: 'Dashboard',
                url: '/',
                icon: <LayoutDashboard className="size-[15px]" />,
                items: [],
                permission: ['System Manager', 'Medical Coder'],
            },
            {
                title: 'Bulk Upload',
                url: '/bulk-upload',
                icon: <MonitorUp className="size-[15px]" />,
                items: [],
                permission: ['System Manager'],
            },
            {
                title: 'Inbox',
                url: '/work-allocation',
                icon: <Inbox className="size-[15px]" />,
                items: [],
                permission: ['System Manager','Medical Coder'],
            },
            {
                title: 'Acitivity Log',
                url: '/activity-log',
                icon: <Logs className="size-[15px]" />,
                items: [],
                permission: ['System Manager'],
            },
            {
                title: 'Client',
                url: '/client',
                icon: <User size={15} color="#ffffff" />,
                permission: ['System Manager'],
                items: [],
            },
            {
                title: 'User',
                url: '/user',
                icon: <User size={15} color="#ffffff" />,
                permission: ['System Manager'],
                items: [],
            },
            {
                title: 'Employee Attendance',
                url: '/employee-attendance',
                icon: <UserRoundCheck size={15} color="#ffffff" />,
                permission: ['System Manager'],
                items: [],
            },
            // {
            //     title: 'Work Allocation',
            //     url: '/work-allocation',
            //     icon: <UserRoundCheck size={15} color="#ffffff" />,
            //     permission: ['System Manager'],
            // },
            {
                title: 'Reports',
                url: '/reports',
                icon: <ChartNoAxesCombined className="size-[15px]" />,
                items: [],
                permission: ['System Manager'],
            },
            {
                title: 'Setup',
                url: '/setup',
                icon: <Settings className="size-[15px]" />,
                items: [
                    {
                        title: 'Payor Type',
                        url: 'setup/payor-type',
                        icon: <Square size={15} color="#ffffff" />,
                        permission: ['System Manager'],
                    },
                    {
                        title: 'HCHB Payor Type',
                        url: '/setup/hchb-payor-type/',
                        icon: <Square size={15} color="#ffffff" />,
                        permission: ['System Manager'],
                    },
                    {
                        title: 'Payor Type Group',
                        url: '/setup/mitem-payor-type/',
                        icon: <Square size={15} color="#ffffff" />,
                        permission: ['System Manager'],
                    },
                    {
                        title: 'Assessment Type',
                        url: 'setup/assessment-type',
                        icon: <Square size={15} color="#ffffff" />,
                        permission: ['System Manager'],
                    },

                    {
                        title: 'Section',
                        url: 'setup/section',
                        icon: <TableOfContents size={15} color="#ffffff" />,
                        permission: ['System Manager'],
                    },
                    {
                        title: 'Mitem',
                        url: 'setup/mitem',
                        icon: <TableOfContents size={15} color="#ffffff" />,
                        permission: ['System Manager'],
                    },
                    {
                        title: 'Hold Reason',
                        url: 'setup/hold-reason',
                        icon: <CirclePause size={15} color="#ffffff" />,
                        permission: ['System Manager'],
                    },
                    {
                        title: 'Technical Issue',
                        url: 'setup/technical-issue',
                        icon: <CirclePause size={15} color="#ffffff" />,
                        permission: ['System Manager'],
                    },
                    {
                        title: 'Followup Status',
                        url: 'setup/followup-status',
                        icon: <GitCommitVertical size={15} color="#ffffff" />,
                        permission: ['System Manager'],
                    },
                    {
                        title: 'Chart Lock issue',
                        url: 'setup/chart-lock-issue',
                        icon: <GitCommitVertical size={15} color="#ffffff" />,
                        permission: ['System Manager'],
                    },
                     {
                        title: 'Shift Type',
                        url: 'setup/shift-type',
                        icon: <TableOfContents size={15} color="#ffffff" />,
                        permission: ['System Manager'],
                    },
                ],
                permission: ['System Manager'],
            },
            {
                title: 'Workflow',
                url: '/workflow',
                icon: <Workflow size={15} color="#ffffff" />,
                items: [
                    {
                        title: 'Workflow State',
                        url: 'workflow/state',
                        icon: <GitCommitVertical ize={15} color="#ffffff" />,
                        permission: ['System Manager'],
                    },
                    {
                        title: 'Workflow Action',
                        url: 'workflow/action',
                        icon: <Edit ize={15} color="#ffffff" />,
                        permission: ['System Manager'],
                    },
                    {
                        title: 'Workflow',
                        url: 'workflow_',
                        icon: <SquareChartGantt ize={15} color="#ffffff" />,
                        permission: ['System Manager'],
                    },
                ],
                permission: ['System Manager'],
            },
            {
                title: 'Configuration',
                url: '/configuration',
                icon: <Boxes className="size-[15px]" />,
                items: [
                    {
                        title: 'Coder Quality Score',
                        url: 'configuration/coder-quality-score',
                        icon: <BookOpenCheckIcon size={15} color="#ffffff" />,
                        permission: ['System Manager'],
                    },
                    {
                        title: 'Group Configuration',
                        url: 'configuration/group-configuration',
                        icon: <Group size={15} color="#ffffff" />,
                        permission: ['System Manager'],
                    },
                    {
                        title: 'Assignment Configuration',
                        url: 'configuration/assignment-configuration',
                        icon: <Group size={15} color="#ffffff" />,
                        permission: ['System Manager'],
                    },
                ],
                permission: ['System Manager'],
            },
            {
                title: 'Access Control',
                url: '/access-control',
                icon: <Lock className="size-[15px]" />,
                items: [
                    {
                        title: 'Permissions',
                        url: 'access-control/permissions',
                        icon: <ShieldX className="size-[15px]" color="#ffffff" />,
                        items: [],
                        permission: ['System Manager'],
                    },
                    {
                        title: 'Settings',
                        url: 'access-control/settings',
                        icon: <Settings2 className="size-[15px]" color="#ffffff" />,
                        items: [],
                        permission: ['System Manager'],
                    },
                ],
                permission: ['System Manager'],
            },
        ],
    }
}

export default SidebarMenu()
